import $ from 'jquery';

class DataLayer {
    constructor(items, eventType) {
        this.itemsToPushData = items;
        this.dataLayer = window.dataLayer = window.dataLayer || [];
        this.eventType = eventType;
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        switch (this.eventType) {
            case 'card':
                this.itemsToPushData.forEach(el => {
                    el.addEventListener('click', () => { this.pushDataLayer(el); });
                });
                break;
            case 'nav':
                this.itemsToPushData.forEach(el => {
                    el.addEventListener('click', () => { this.pushNavDataLayer(el); });
                });
                break;
            default:
                this.itemsToPushData.forEach(el => {
                    el.addEventListener('click', () => { this.pushDataLayer(el); });
                });
                break;
        }
    }

    pushNavDataLayer(el) {
        this.dataLayer.push({
            event: 'navigation_interaction',
            attributes: {
                data_navType: (el.dataset.navtype) ? el.dataset.navtype : '',
                data_parent: (el.dataset.parent) ? el.dataset.parent : '',
                data_click_text: (el.dataset.text) ? el.dataset.text : '',
                data_menu_type: (el.dataset.menutype) ? el.dataset.menutype : '',
                data_click_url: (el.dataset.url) ? el.dataset.url : ''
            }
        });
    }

    pushDataLayer(el) {
        this.dataLayer.push({
            event: 'cta_card_click',
            attributes: {
                click_text: (el.dataset.text) ? el.dataset.text : '',
                click_text_title: (el.dataset.title) ? el.dataset.title : '',
                click_url: (el.dataset.url) ? el.dataset.url : ''
            }
        });
    }
}

export default DataLayer;

$(() => {
    if ($('.dl-elem').length) {
        const dataLayer = new DataLayer(document.querySelectorAll('.dl-elem'), 'card');
        dataLayer.init();
    }

    if ($('.dl-nav').length) {
        const dataLayer = new DataLayer(document.querySelectorAll('.dl-nav'), 'nav');
        dataLayer.init();
    }
});